<template>
  <highliter
    v-model="section.name"
    :dublicate="section"
    :dublicate-deep="parentUID"
    active-class="z-100"
    class="highlight-element"
    section-type="element"
    :hide-bar="hideBar"
    :hide-add="hideAdd"
    @delete="$emit('delete')"
    @dublicate="$emit('dublicate')"
    @favorite="$emit('favorite', $el)"
    @flow="handleFlow"
    @move-to="to => $emit('move-to', to)"
    @add-subject="$emit('add-subject')"
    @click.stop.native="sectionSettings('carousel-mod-v4')"
  >
    <div
      class="embla"
      :class="[`--${section.sid}--wrapper --${section.sid}--element`, {'element-hidden': !visability('carousel')}]"
      :data-sid="section.sid"
    >
      <div class="relative w-full h-full">
        <div
          ref="viewport"
          class="embla__viewport"
          :class="`--${section.sid}--slider`"
        >
          <div
            class="embla__container"
            :class="`--${section.sid}--container`"
            :style="{
              '--slide-size': `${100 / slidesPerView}%`,
              height: vertical ? 'var(--slide-height, 150px)' : null,
              flexDirection: direction
            }"
          >
            <div
              v-for="(slide, index) in section.options.content.carousel.slides"
              :key="index"
              :data-sid="`${section.sid}--${slide.uid}`"
              class="embla__slide"
              :class="`--${section.sid}--slide`"
            >
              <div
                class="block-bg"
                :class="`--${section.sid}--${slide.uid}--bg`"
              />

              <div class="no-embla-drag">
                <elements
                  v-model="slide.content"
                  class="h-100 p-[2px]"
                  :classes="`--${section.sid}--content w-100 h-100 flex flex-col`"
                  drag-height="150px"
                  @flow="handleFlow"
                  @click.stop.native="$store.commit('editor/SET_PAGE', 'add-element')"
                />
              </div>
            </div>
          </div>
        </div>

        <button
          class="embla__prev slide-btn slide-prev-btn custom"
          :class="[
            `--${section.sid}--prev-btn`,
            {'opacity-80': !canScrollPrev}
          ]"
          :disabled="!canScrollPrev"
          @click.stop="scrollPrev"
        >
          <i :class="section.options.content.carousel.prevIcon" />
        </button>

        <button
          class="embla__next slide-btn slide-next-btn custom"
          :class="[
            `--${section.sid}--next-btn`,
            {'opacity-80': !canScrollNext}
          ]"
          :disabled="!canScrollNext"
          @click.stop="scrollNext"
        >
          <i :class="section.options.content.carousel.nextIcon" />
        </button>
      </div>

      <div
        class="embla__dots"
        :class="`--${section.sid}--pagination`"
      >
        <button
          v-for="(item, index) in section.options.content.carousel.slides"
          :key="index"
          class="embla__dot opacity-60"
          :class="[
            `--${section.sid}--pagination-item --${section.sid}--${item.uid}--pagination-item`,
            section.options.content.carousel.paginationThumbnails ? `--${section.sid}--${item.uid}--thumbnail` : '',
            {'embla__dot--selected !opacity-100': selectedScrollSnap === index}
          ]"
          @click.stop="scrollTo(index)"
        />
      </div>
    </div>
  </highliter>
</template>

<script>
import EmblaCarousel from 'embla-carousel'
import Autoplay from 'embla-carousel-autoplay'
import AutoScroll from 'embla-carousel-auto-scroll'
// import AutoHeight from 'embla-carousel-auto-height'
import {WheelGesturesPlugin} from 'embla-carousel-wheel-gestures'
import SectionMixin from '@/components/mixins/SectionMixin'
import EventsMixin from '@/components/editor/mixins/EventsMixin'
import Elements from '@/components/builder/utils/Elements/Elements.vue'
export default {
  name: 'ElCarouselV4',
  components: {Elements},
  mixins: [SectionMixin, EventsMixin],
  data () {
    return {
      canScrollPrev: false,
      canScrollNext: false,
      selectedScrollSnap: 0,
      scrollSnapList: []
    }
  },
  computed: {
    slidesPerView () {
      return this.section.options.content.carousel.slidesPerView[this.resolutioner] || 1
    },
    vertical () {
      return this.section.options.content.carousel.vertical[this.resolutioner] || false
    },
    direction () {
      const carouselOptions = this.section.options.content.carousel

      if (this.vertical) {
        return carouselOptions.reverseDirection ? 'column-reverse' : 'column'
      } else {
        return carouselOptions.reverseDirection ? 'row-reverse' : 'row'
      }
    },
    options () {
      const carouselOptions = this.section.options.content.carousel
      return {
        align: carouselOptions.centeredSlides[this.resolutioner] ? 'center' : 'start',
        axis: this.vertical ? 'y' : 'x',
        direction: carouselOptions.reverseDirection ? 'rtl' : 'ltr',
        dragFree: carouselOptions.dragFree,
        duration: carouselOptions.speed,
        loop: carouselOptions.loop,
        slidesToScroll: carouselOptions.scrollSlidesCount[this.resolutioner],
        watchDrag: (embla, evt) => {
          return !evt.target.closest('.no-embla-drag')
        }
      }
    },
    plugins () {
      const carouselOptions = this.section.options.content.carousel
      return [
        WheelGesturesPlugin(),
        // AutoHeight(),
        carouselOptions.autoplay
          ? Autoplay({
            delay: carouselOptions.autoplayDelay ? carouselOptions.autoplayDelay * 1000 : 4000,
            stopOnMouseEnter: carouselOptions.stopOnMouseEnter
          })
          : null,
        carouselOptions.autoscroll
          ? AutoScroll({
            speed: carouselOptions.startSpeed,
            startDelay: carouselOptions.startDelay ? carouselOptions.startDelay * 1000 : 1000,
            stopOnMouseEnter: carouselOptions.stopOnMouseEnter
          })
          : null
      ].filter(plugin => plugin !== null)
    }
  },
  methods: {
    scrollPrev () {
      this.emblaApi?.scrollPrev()
    },
    scrollNext () {
      this.emblaApi?.scrollNext()
    },
    scrollTo (index) {
      this.emblaApi?.scrollTo(index)
    },
    isNewSlide () {
      this.canScrollPrev = this.emblaApi?.canScrollPrev()
      this.canScrollNext = this.emblaApi?.canScrollNext()
      this.selectedScrollSnap = this.emblaApi?.selectedScrollSnap()
      this.scrollSnapList = this.emblaApi?.scrollSnapList()
    }
  },
  watch: {
    options (val) {
      if (this.emblaApi) {
        this.emblaApi.reInit(val, this.plugins)
      }
    },
    plugins (val) {
      if (this.emblaApi) {
        this.emblaApi.reInit(this.options, val)
      }
    }
  },
  mounted () {
    const carouselOptions = this.section.options.content.carousel

    if (typeof carouselOptions.vertical !== 'object') {
      this.section.options.content.carousel.vertical = {
        lg: false,
        md: false,
        sm: false
      }
    }

    if (typeof carouselOptions.centeredSlides !== 'object') {
      this.section.options.content.carousel.centeredSlides = {
        lg: false,
        md: true,
        sm: true
      }
    }

    if (typeof carouselOptions.scrollSlidesCount !== 'object') {
      this.section.options.content.carousel.scrollSlidesCount = {
        lg: 1,
        md: 1,
        sm: 1
      }
    }

    if (typeof carouselOptions.slidesPerView !== 'object') {
      this.section.options.content.carousel.slidesPerView = {
        lg: 2,
        md: 1,
        sm: 1
      }
    }

    setTimeout(() => {
      const viewportNode = this.$refs.viewport
      this.emblaApi = EmblaCarousel(viewportNode, this.options, this.plugins)

      this.emblaApi
        .on('select', this.isNewSlide)
        .on('init', this.isNewSlide)
        .on('reInit', this.isNewSlide)
    }, 250)
  },
  beforeDestroy () {
    if (this.emblaApi) {
      this.emblaApi.destroy()
      this.emblaApi = null
    }
  }
}
</script>

<style>
.embla {
  width: 100%;
  margin: auto;
}

.embla__viewport {
  overflow: hidden;
}

.embla__container {
  position: relative;
  display: flex;
  touch-action: pan-y pinch-zoom;
  margin-right: calc(var(--slide-spacing, 10px) * -1);
  transition: height 0.2s;
}

.embla__slide {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: var(--slide-size, 100%);
  height: var(--slide-height);
  margin-right: var(--slide-spacing, 10px);
  overflow: clip;
  min-width: 0;
  transform: translate3d(0, 0, 0);
}

.embla__dots {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
}

.embla__dot {
  display: flex;
  cursor: pointer;
  padding: 0;
  width: var(--dot-size, 1rem);
  height: var(--dot-size, 1rem);
  border-radius: var(--dot-radius, 50%);
}
</style>